import { Box } from "@mui/material";
import { getOrganizationPreference } from "api/services/common";
import { snack } from "components/toast";
import useTitle from "hooks/useTitle";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ResType } from "types";
import EproceedingFya from "views/atom-pro/eProceedingFYA";
import EproceedingFyi from "views/atom-pro/eProceedingFYI";
import { StyledProfileNavItem } from "views/clients/styles";
import { Permissions } from "data/permissons";
import { usePermissions } from "context/PermissionsProvider";
import IncomeTaxKeyPersonDetails from "./income-tax-key-person-details";
import IncomeTaxDscRegisters from "./income-tax-dsc-registers";

const IncomeTaxDsc = () => {
  useTitle("ATOM Pro | DSC");
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "IND";
  const [active, setActive] = useState(defaultTab);
  const { permissions } = usePermissions();

  useEffect(() => {
    setActive(defaultTab);
  }, [defaultTab]);

  const handleTabChange = (tab: string) => {
    setActive(tab);
    setSearchParams({ tab });
  };

  const { data: incomeTaxAccess, isLoading: isLoadingIncomeTaxAccess }: ResType = useQuery(
    ["Income Tax Access Check"],
    getOrganizationPreference,
    {
      onSuccess: (res: any) => {
        if (res?.data?.automationConfig?.incomeTax === "YES") {
        } else {
          snack.error("Please subscribe Atom Pro Income tax");
          navigate("/atom-pro/incomeTaxLimit");
        }
      },
      enabled:
        permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
        permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS),
    }
  );

  return (
    <>
      <Box
        mb={1}
        display="flex"
        gap="15px"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        bgcolor="#F5F5F5"
      >
        <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={active === "IND" ? 1 : 0}
          onClick={() => handleTabChange("IND")}
          sx={{ marginLeft: "10px" }}
        >
          Individual Assesses
        </StyledProfileNavItem>
        <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={active === "OTH" ? 1 : 0}
          onClick={() => handleTabChange("OTH")}
        >
          Authorized Signatories
        </StyledProfileNavItem>
      </Box>

      {active === "IND" && <IncomeTaxDscRegisters />}
      {active === "OTH" && <IncomeTaxKeyPersonDetails />}
    </>
  );
};

export default IncomeTaxDsc;
